import CloseIcon from '@mui/icons-material/Close';
import { Box, Modal, IconButton } from '@mui/material';
import React, { useEffect } from 'react';

import { removeOtpFromSessionStorage } from '../../services/database/mfa-auth';

import { OtpVerfication } from './Otp';

const style = {
  // eslint-disable-next-line @typescript-eslint/prefer-as-const
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

type PopupProps = {
  isOtpSent: boolean;
};

const OtpPopup: React.FC<PopupProps> = ({ isOtpSent }) => {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    void removeOtpFromSessionStorage();
    setOpen(false);
  };

  useEffect(() => {
    if (isOtpSent) {
      setOpen(true);
    }
  }, [isOtpSent]);

  return (
    <React.Fragment>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEscapeKeyDown
        BackdropProps={{
          onClick: (e) => e.stopPropagation(),
        }}
      >
        <Box className="cstm-popup" sx={style}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <OtpVerfication />
        </Box>
      </Modal>
    </React.Fragment>
  );
};

export default OtpPopup;
